import {Component} from '@packages/systems/wfdl';
import {ERecord, EUnion, ENumber} from '@packages/systems/wfdl-ast';
import {type BreakpointID} from '@packages/systems/style/types';
import {
  FRAME_DIMENSION_MODE,
  setFrameSetting,
  resetFrameSetting,
  type GetBaseVariantId,
  getBaseVariantIdForNativeComponent,
} from './frameUtils';

const valueToExpression = (value: 'fit' | 'full' | number) =>
  typeof value === 'number'
    ? ERecord({
        mode: EUnion({tag: FRAME_DIMENSION_MODE.FIXED, value: ERecord({})}),
        value: ENumber(value),
      })
    : ERecord({
        mode: EUnion({tag: value, value: ERecord({})}),
        value: ENumber(0),
      });

const defaultWidthExpr = ERecord({
  mode: EUnion({tag: FRAME_DIMENSION_MODE.FULL, value: ERecord({})}),
  value: ENumber(0),
});

const defaultHeightExpr = ERecord({
  mode: EUnion({tag: FRAME_DIMENSION_MODE.FIT, value: ERecord({})}),
  value: ENumber(0),
});

// Sets frame dimensions with inheritance logic
export function setFrameDimension(
  componentMap: Component.ComponentMap,
  elementId: string,
  mediaQuery: BreakpointID,
  dimension: 'width' | 'height',
  value: 'fit' | 'full' | number,
  getBaseVariantId: GetBaseVariantId = getBaseVariantIdForNativeComponent
): Component.ComponentMap {
  return setFrameSetting(
    componentMap,
    elementId,
    mediaQuery,
    dimension,
    valueToExpression(value),
    getBaseVariantId
  );
}

export function resetFrameDimension(
  componentMap: Component.ComponentMap,
  elementId: string,
  mediaQuery: BreakpointID,
  dimension: 'width' | 'height',
  getBaseVariantId: GetBaseVariantId = getBaseVariantIdForNativeComponent
): Component.ComponentMap {
  return resetFrameSetting(
    componentMap,
    elementId,
    mediaQuery,
    dimension,
    dimension === 'width' ? defaultWidthExpr : defaultHeightExpr,
    getBaseVariantId
  );
}
